import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { requestPasswordReset } from '../../api/auth.api';
import { ForgotPasswordForm, SuccessMessage } from '../../components/auth';
import LOGO from '../../assets/LOGO (2).png';
import featureIcon1 from '../../assets/material-symbols_space-dashboard.png';
import featureIcon2 from '../../assets/streamline_money-graph-analytics-business-product-graph-data-chart-analysis.png';
import featureIcon3 from '../../assets/ix_user-management-settings-filled.png';
import featureIcon4 from '../../assets/fluent-mdl2_b-i-dashboard.png';
import ellipse1 from '../../assets/Ellipse 1.png';
import ellipse2 from '../../assets/Ellipse 2.png';
import ellipse3 from '../../assets/Ellipse 3.png';
import ellipse4 from '../../assets/Ellipse 4.png';

const RightPanel = () => (
  <div className="relative hidden h-full w-full items-center justify-center overflow-hidden bg-teal-700 px-10 py-16 text-white lg:flex">
    <div className="absolute inset-0">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.12),transparent_45%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_80%,rgba(255,255,255,0.08),transparent_50%)]" />
    </div>

    <div className="relative z-10 flex h-full w-full max-w-xl items-start justify-center px-6 pt-2">
      <div className="relative h-[29rem] w-[29rem]">
        <div className="absolute left-[14rem] top-0 flex flex-col items-center text-center">
          <div className="relative flex h-28 w-28 items-center justify-center drop-shadow-[0_18px_32px_rgba(0,0,0,0.26)]">
            <img src={ellipse1} alt="" aria-hidden className="h-full w-full object-contain" />
            <img src={featureIcon1} alt="Espace sécurisé" className="absolute h-12 w-12" />
          </div>
          <p className="mt-3 text-base font-medium text-white">Espace sécurisé</p>
        </div>

        <div className="absolute left-[0rem] top-[9rem] flex flex-col items-center text-center">
          <div className="relative flex h-28 w-28 items-center justify-center drop-shadow-[0_18px_32px_rgba(0,0,0,0.26)]">
            <img src={ellipse3} alt="" aria-hidden className="h-full w-full object-contain" />
            <img src={featureIcon3} alt="Gestion simplifiée" className="absolute h-12 w-12" />
          </div>
          <p className="mt-3 text-base font-medium text-white">Gestion simplifiée</p>
        </div>

        <div className="absolute left-[18rem] top-[11rem] flex flex-col items-center text-center">
          <div className="relative flex h-28 w-28 items-center justify-center drop-shadow-[0_18px_32px_rgba(0,0,0,0.26)]">
            <img src={ellipse2} alt="" aria-hidden className="h-full w-full object-contain" />
            <img
              src={featureIcon2}
              alt="Suivi en temps réel"
              className="absolute h-12 w-12 filter brightness-0 invert"
            />
          </div>
          <p className="mt-3 text-base font-medium text-white">Suivi en temps réel</p>
        </div>

        <div className="absolute left-[-1rem] top-[20rem] flex flex-col items-center text-center">
          <div className="relative flex h-28 w-28 items-center justify-center drop-shadow-[0_18px_32px_rgba(0,0,0,0.26)]">
            <img src={ellipse4} alt="" aria-hidden className="h-full w-full object-contain" />
            <img src={featureIcon4} alt="Support continu" className="absolute h-12 w-12" />
          </div>
          <p className="mt-3 text-base font-medium text-white leading-snug text-center">
            Un accompagnement constant pour vos équipes.
          </p>
        </div>
      </div>
    </div>
  </div>
);

const MotDePasseOublie = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (emailValue) => {
    setIsLoading(true);

    try {
      await requestPasswordReset(emailValue);
      setEmail(emailValue);
      setEmailSent(true);
      toast.success('Un email de réinitialisation a été envoyé à votre adresse email.');
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          toast.error(data?.email?.[0] || 'Adresse email invalide.');
        } else if (status === 404) {
          toast.error('Aucun compte trouvé avec cette adresse email.');
        } else {
          toast.error(data?.detail || `Erreur (${status}). Veuillez réessayer.`);
        }
      } else if (error.request) {
        toast.error('Le serveur ne répond pas. Vérifie ta connexion réseau.');
      } else {
        toast.error('Erreur de configuration de la requête.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-[1fr_1fr]">
      <div className="flex flex-col justify-center items-center bg-white relative px-6 py-10 sm:px-12 md:px-16 lg:px-0">
        <div className="relative z-10 flex w-full max-w-lg flex-col items-center gap-6">
          <div className="text-center">
            <img src={LOGO} alt="logo-easy-survey" className="mx-auto mb-5 h-20 w-auto" />
            <h1 className="text-2xl font-semibold text-gray-900">Réinitialiser mon mot de passe</h1>
            <p className="mt-2 text-base font-medium text-gray-700">
              Récupérez l'accès à votre espace en toute simplicité.
            </p>
          </div>

          {emailSent ? (
            <SuccessMessage email={email} onReturnClick={() => navigate('/')} />
          ) : (
            <>
              <ForgotPasswordForm onSubmit={handleSubmit} isLoading={isLoading} />

              <p className="mt-2 text-center text-sm text-gray-600">
                Vous avez retrouvé votre mot de passe ?{' '}
                <Link to="/" className="font-semibold text-[#008f78] transition hover:text-[#00967d] hover:underline">
                  Revenir à la connexion
                </Link>
              </p>
            </>
          )}
        </div>
      </div>

      <RightPanel />
    </div>
  );
};

export default MotDePasseOublie;
